import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import '../styles/ResetPasswordVerify.css';

import { ApiContext } from '../context/ApiContext';
const ResetPasswordVerify = () => {
    const location = useLocation();
    const apiUrl = useContext(ApiContext);
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email') || '';
    const resetCodeFromQuery = queryParams.get('resetCode') || '';
    // console.log('Email passed to ResetPasswordVerify:', email);
    const [resetCode, setResetCode] = useState(resetCodeFromQuery || '');
    const [password, setPassword] = useState('');

    const navigate = useNavigate();
    const handleResetPasswordVerify = async () => {
        try {
            const response = await fetch(`${apiUrl}/api/v1/reset-password/verify`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ resetCode, email, password }),
            });

            if (response.ok) {
                const { accessToken, accessTokenExpiresAt, refreshToken, refreshTokenExpiresAt } = await response.json();
                localStorage.setItem('accessToken', accessToken);
                localStorage.setItem('accessTokenExpiresAt', accessTokenExpiresAt);
                localStorage.setItem('refreshToken', refreshToken);
                localStorage.setItem('refreshTokenExpiresAt', refreshTokenExpiresAt);
                alert('Congratulations! Your password has been reset successfully. Enjoy your time!');
                navigate('/posts');
            } else {
                alert('ResetPasswordVerify Failed!');
            }
        } catch (error) {
            console.error('Error during login:', error);
            alert('An error occurred. Please try again.');
        }
    };

    return (
        <div className="ResetPasswordVerify">
            <h2>Forgot Password</h2>
            <form>
                <div>
                    <label>We've sent you an email with reset code.</label>
                    <label>Please check your inbox.</label>
                    <label>Reset code</label>
                    <input
                        type="text"
                        value={resetCode}
                        onChange={(e) => setResetCode(e.target.value)}
                        placeholder="XXXXX-XXXXX"
                        required
                    />
                </div>
                <div>
                    <label>New password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="form-buttons">
                    <button type="button" onClick={() => window.history.back()}>Back</button>
                    <button type="button" onClick={handleResetPasswordVerify}>Next</button>
                </div>
            </form>
        </div>
    );
};

export default ResetPasswordVerify;
